export const useAnimate = (currentSliderValue, maxSliderIndex) => {
  const isPlaying = ref(false)
  const clearId = ref(null)

  const anime = () => {
    if (!isPlaying.value) return

    const nextValue = currentSliderValue.value < maxSliderIndex.value ? currentSliderValue.value + 1 : 0
    currentSliderValue.value = nextValue

    const delay = nextValue === maxSliderIndex.value ? 2000 : 1000
    clearId.value = setTimeout(anime, delay)
  }

  const onClickPlay = () => {
    isPlaying.value = true
    clearTimeout(clearId.value)
    anime()
  }
  const onClickStop = () => {
    isPlaying.value = false
    clearTimeout(clearId.value)
  }

  return {
    isPlaying,
    clearId,
    onClickPlay,
    onClickStop
  }
}
